<p>{{xml | json}}</p>